import React, { useState, useEffect } from 'react'
import { Panel, Placeholder } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../../constants/project'
import { cloneDeep } from 'lodash-es'
import { getSummaryOfDepartment } from '../../../redux/actions/auditDashboard'

export default function SummaryOfDepartmentChart({ request }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [chartOption, setChartOption] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [request])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getSummaryOfDepartment(request)
      // const response = mockSchema
      let charts = cloneDeep(chartSchema)

      let seriesDatas = []
      response?.chartDatas.forEach((e) => {
        let seriesData = cloneDeep(seriesDataSchema)

        seriesData.name = e.name
        seriesData.data = e.value

        seriesDatas.push(seriesData)
      })

      charts.title.text =
        response?.chartTitle || 'แสดงจำนวนโครงการ โครงการรับทุนที่พบประเด็น แยกตามสำนัก'
      charts.xAxis.data = response?.category || []
      charts.series = seriesDatas

      // console.log('SummaryOfDepartmentChart : ', JSON.stringify(charts))

      setSchema(response)
      setChartOption(charts)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {schema && (
        <Panel
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          style={{ marginTop: 20 }}
          shaded
        >
          {isLoading && <Placeholder.Graph active />}
          {chartOption && (
            <ReactECharts
              theme={CHART_THEME}
              option={chartOption}
              style={{ minHeight: '440px', width: '100%' }}
              className={'react_for_echarts'}
            />
          )}
        </Panel>
      )}
    </>
  )
}

const seriesDataSchema = {
  name: '',
  type: 'bar',
  data: [],
  // itemStyle: { normal: { color: '#63c2ff' } },
  // itemStyle: { normal: { color: '#dd8b90' } },
  // itemStyle: { normal: { color: '#ffc184' } },
  // itemStyle: { normal: { color: '#41b596' } },
}

const colors = ['#63c2ff', '#dd8b90', '#ffc184', '#41b596']
const chartSchema = {
  title: {
    text: '',
    subtext: '',
    left: 'left',
    top: '10',
    textStyle: {
      color: '#008acd',
      opacity: '0.7',
      fontWeight: '400',
      fontSize: '1rem',
    },
  },
  color: colors,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  toolbox: {
    show: true,
    feature: {
      //dataView: { show: true, readOnly: false },
      saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
    },
  },
  legend: {
    top: '40',
    left: 'center',
  },
  grid: {
    left: '3%',
    right: '3%',
    top: '80',
    bottom: '50',
    containLabel: true,
  },
  // แนวตั้ง
  // xAxis: {
  //   type: 'category',
  //   data: [],
  // },
  // yAxis: {
  //   type: 'value',
  //   boundaryGap: [0, 0.01],
  // },

  //แนวนอน
  xAxis: {
    type: 'category',
    data: [
      'สำนัก 1',
      'สำนัก 2',
      'สำนัก 3',
      'สำนัก 4',
      'สำนัก 5',
      'สำนัก 6',
      'สำนัก 7',
      'สำนัก 8',
      'สำนัก 9',
      'สำนัก 10',
      'สภส.',
      'ศศร.',
      'สำนักวิชาการและนวัตกรรม',
      'ฝ่ายสื่อสารองค์กร',
      'ฝ่ายติดตามประเมิน',
    ],
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, 0.01],
  },
  dataZoom: [
    {
      type: 'slider',
      show: true,
      xAxisIndex: 0,
      // yAxisIndex: [0, 1],
      // start: 1,
      // end: 100,
    },
    {
      type: 'inside',
      xAxisIndex: 0,
      // yAxisIndex: [0, 1],
      // start: 1,
      // end: 35,
    },
  ],
  series: [],
}
